import { NavLink } from 'react-router-dom';
import { HomeIcon, ArrowLeftIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';

export default function NotFound() {
  return (
    <div className="relative flex min-h-[70vh] items-center overflow-hidden bg-soft-gradient">
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        <div className="absolute inset-0 dot-grid-bg opacity-50 [mask-image:radial-gradient(50%_50%_at_50%_50%,black,transparent)]" />
        <div className="absolute left-1/4 top-10 h-64 w-64 animate-blob rounded-full bg-brand-300/30 blur-3xl" />
        <div className="absolute bottom-0 right-1/4 h-64 w-64 animate-blob rounded-full bg-fuchsia-300/25 blur-3xl [animation-delay:-8s]" />
      </div>

      <div className="container-page relative py-20 text-center">
        <p className="text-[6rem] font-extrabold leading-none text-gradient sm:text-[9rem]">
          404
        </p>
        <h1 className="mt-2 text-2xl font-extrabold text-slate-900 sm:text-3xl">
          Halaman tidak ditemukan
        </h1>
        <p className="mx-auto mt-3 max-w-md text-sm leading-6 text-slate-600">
          Sepertinya link yang kamu buka sudah pindah atau tidak pernah ada.
          Yuk kembali menjelajah katalog.
        </p>

        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <NavLink to="/" className="btn-primary">
            <HomeIcon className="h-4 w-4" /> Ke Home
          </NavLink>
          <NavLink to="/icons" className="btn-secondary">
            <MagnifyingGlassIcon className="h-4 w-4" /> Cari produk
          </NavLink>
        </div>

        <NavLink
          to="/list"
          className="group mt-8 inline-flex items-center gap-1.5 text-sm font-semibold text-slate-500 transition hover:text-brand-700"
        >
          <ArrowLeftIcon className="h-4 w-4 transition group-hover:-translate-x-0.5" />
          Lihat data produk
        </NavLink>
      </div>
    </div>
  );
}
